/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Metric_DurationInputs */

const en_us2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const pt_br2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

const es_419_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo`)
};

const pt_pt2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

const fr_fr2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const de_de2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

const it_it2_exercise_sheet_metric_duration = /** @type {(inputs: Exercise_Sheet_Metric_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Exercise_Sheet_Metric_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_metric_duration = /** @type {((inputs?: Exercise_Sheet_Metric_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Metric_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_metric_duration(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_metric_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_metric_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_metric_duration(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_metric_duration(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_metric_duration(inputs)
	return en_us2_exercise_sheet_metric_duration(inputs)
});
export { exercise_sheet_metric_duration as "exercise-sheet.metric_duration" }